import { isUnknownPayment } from '../../Common/utils/paymentResult';

export function adminPaymentStatus(row) {
  const display = String(row?.display_status ?? row?.displayStatus ?? '').toUpperCase();
  const transaction = String(row?.transaction_status ?? row?.transactionStatus ?? '').toUpperCase();
  if (isUnknownPayment(row) || display === 'UNKNOWN') return 'UNKNOWN';
  if (display === 'CLOSED_BY_USER' || transaction === 'CLOSED_BY_USER') return 'CLOSED_BY_USER';
  // Preserve existing statuses for other providers and manual payments.
  return row?.transaction_status ?? row?.transactionStatus ?? '';
}
export const isClosedAdminPayment = (row) => adminPaymentStatus(row) === 'CLOSED_BY_USER';
export const canShowAdminReceipt = (row) => !isClosedAdminPayment(row) && (row?.can_show_receipt ?? row?.canShowReceipt) !== false;
export function adminDisplayFee(row) {
  if (isClosedAdminPayment(row)) return row.display_fee_amount ?? row.displayFeeAmount ?? 0;
  return row.display_fee_amount ?? row.displayFeeAmount ?? row.cp_fee_amount ?? row.cpFeeAmount ?? row.fee_amt ?? row.feeAmt ?? row.fee_amount ?? row.fee ?? 0;
}
export function adminDisplayMessage(row) {
  if (isClosedAdminPayment(row)) return row.display_message ?? row.displayMessage ?? '결제창이 종료되어 결제가 완료되지 않았습니다.';
  return row.display_message ?? row.displayMessage ?? row.resultMessage ?? row.out_rslt_msg ?? row.outRsltMsg ?? '';
}
export function adminTransactionCount(summary, dataTotal, loadedCount) {
  // Includes CLOSED and UNKNOWN; never reconstruct total from status subtotals.
  return Number(summary.transactionCount ?? summary.transaction_count ?? dataTotal ?? loadedCount);
}
